module.exports = __webpack_public_path__ + "static/fx_4.8e65fa50.jpg";